import {
  CustomFieldDataType,
  CustomFieldEntity,
  CustomListItemStyle,
  Report,
} from 'shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { useColumns } from './hooks/useColumns'
import CIMSTable from 'components/CIMSTable'
import { HelpMessage } from 'utils/constants'
import { useCustomFieldPageContext } from '../../CustomFieldPageContext'
import { ProjectCustomField } from 'components/CustomFields/ProjectCustomFieldsContext/types'

export function useExpand(): ExpandOptions<ProjectCustomField> {
  const { columns, editing } = useColumns()
  const { refetch } = useProjectCustomFieldsContext()
  const { edit } = useCustomFieldPageContext()
  const help = HelpMessage.Administration.CustomFields
  return {
    render: ({
      id,
      deleted,
      dataTypeId,
      metadata,
      customFieldToClassTypes,
      customListItems,
    }) => ({
      additionalInfo: !CustomFieldDataType.usesMetadata(dataTypeId)
        ? undefined
        : [
            {
              hidden: dataTypeId !== CustomFieldDataType.Entity.id,
              label: 'Record Link Types',
              help: help.RecordLinkTypes,
              type: 'tags',
              tags:
                metadata.entityIds?.map((id) => ({
                  text: CustomFieldEntity.fromIdOrFail(id).type,
                })) ?? [],
            },
            {
              label: 'Reports',
              help: help.Reports,
              hidden: dataTypeId !== CustomFieldDataType.Report.id,
              type: 'tags',
              tags:
                metadata.reportIds?.map((id) => ({
                  text: Report.fromIdOrFail(id).name,
                })) ?? [],
            },
            {
              label: 'Timestamp',
              help: help.Timestamp,
              hidden: dataTypeId !== CustomFieldDataType.Date.id,
              type: 'checkbox',
              checked: metadata?.timestamp ?? false,
              disabled: [
                {
                  disabled: !edit.can,
                  reason: 'missing permission',
                },
                {
                  disabled: deleted,
                  reason: { why: 'inactive' },
                },
              ],
              onChange: {
                callback: async () => {
                  if (!edit.can) return
                  await edit.fn({
                    variables: {
                      editCustomFieldInput: {
                        id,
                        metadata: { timestamp: !metadata?.timestamp },
                      },
                    },
                  })
                  refetch()
                },
                loadingKey: `timestamp-${id}`,
              },
            },
            {
              label: 'Style',
              help: help.Style,
              hidden: dataTypeId !== CustomFieldDataType.List.id,
              children: metadata?.styleId
                ? CustomListItemStyle.fromId(metadata?.styleId)?.label
                : null,
            },
            {
              label: 'Items',
              help: help.Items,
              hidden: dataTypeId !== CustomFieldDataType.List.id,
              type: 'tags',
              tags: customListItems.map(({ value }) => ({ text: value })),
            },
          ],
      custom: [
        {
          label: 'Record Types',
          children: (
            <div
              style={{
                /**
                 * the width of all the columns + 32 for the "scrollbar" column
                 */
                maxWidth: 200 + 142 + 152 + 111 + 118 + 300 + 32,
              }}
            >
              <CIMSTable
                key={id}
                rowKey="classTypeId"
                records={customFieldToClassTypes.map((cf2ct) => ({
                  ...cf2ct,
                  customField: { id, deleted },
                }))}
                columns={columns}
                loading={editing}
                disable={{ showAll: true }}
              />
            </div>
          ),
        },
      ],
    }),
  }
}
